import groupifier from "./assets/Groupifier.png";
import dailydose from "./assets/logo 1.svg";
import aki from "./assets/Aki.png";
import space from "./assets/spaceProject.png";
import podcast from "./assets/podcasts.png";

export const products = [
  {
    id: 1,
    img: aki,
    link: "https://www.figma.com/proto/i0tJjuxPi3Bhl421WVRXKz/OMNI-Hacks?page-id=2%3A2&node-id=13%3A4&starting-point-node-id=13%3A4",
  },
  {
    id: 2,
    img: groupifier,
    link: "https://devpost.com/software/groupifier",
  },
  {
    id: 3,
    img: dailydose,
    link: "https://github.com/sun971/DailyDoseOfCare",
  },
  {
    id: 4,
    img: space,
    link: "https://github.com/sun971/Nasa-gram",
  },
  {
    id: 5,
    img: podcast,
    link: "https://anchor.fm/dive-deeper-podcast",
  },
  // TODO: place last project
  //   {
  //     id: 6,
  //     img: "",
  //     link: "http://lama.dev",
  //   },
];
